import Vue from 'vue';

export default {
  state: {
    selectedScene: null,
    unsavedScenes: [],
  },
  getters: {
    getSelectedScene: (state) => state.selectedScene,
    getUnsavedScenes: (state) => state.unsavedScenes,
  },
  mutations: {
    addUnsavedScene(state, payload) {
      const { _id } = payload;

      if (!state.unsavedScenes.find((s) => s._id === _id)) {
        state.unsavedScenes.push(payload);
      }
    },
    saveUnsavedScene(state, payload) {
      const scene = state.unsavedScenes.find((s) => s._id === payload);
      const removeIndex = state.unsavedScenes.map((s) => s._id).indexOf(payload);

      if (scene.type === 'scene') {
        const indexOfScene = state.selectedProject.scenes.map((e) => e._id).indexOf(payload);

        Vue.set(state.selectedProject.scenes, indexOfScene, { ...scene });
      } else if (scene.type === 'subscene') {
        const parentId = scene.parentId;
        const indexOfScene = state.selectedProject.scenes.map((e) => e._id).indexOf(parentId);

        Vue.set(state.selectedProject.scenes[indexOfScene].subscenes, scene.index, { ...scene });
      }

      state.unsavedScenes.splice(removeIndex, 1);
    },
    setSelectedScene(state, payload) {
      state.selectedScene = payload;
    },
    changeScene(state, payload) {
      const { id, update } = payload;
      const indexOfScene = state.selectedProject.scenes.map((e) => e.id).indexOf(id);
      let updatedScene = state.selectedProject.scenes.find((scene) => scene.id === id);

      updatedScene = {
        ...updatedScene,
        ...update,
      };

      Vue.set(state.selectedProject.scenes, indexOfScene, { ...updatedScene });
    },
  },
};
